module.exports = __webpack_public_path__ + "LatoLatin-MediumItalic.80cd5551d5217c0cad97.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-MediumItalic.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-MediumItalic.ttf
// module chunks = styles